import React from 'react'
import { Footer } from '../Footer'
import { Alert } from '@ztechapps/webui.util'
import { useContext as useParentContext } from '../Context'
import filter from 'lodash/filter'

export const Layout = () => {
  const { components, ...parentContext } = useParentContext()
  return (
    <React.Fragment>
      <Alert type="warning">
        <ul>
          <li className="small">Choose a project from the dropdown</li>
          <li className="small">Only those un-assigned task will be show</li>
          <li className="small">Check the box for which task you want to include</li>
        </ul>
      </Alert>
      <components.projectContent
        {...{
          ...parentContext,
          onTaskSelect: ({ tasks }) => {
            const filtered = filter(tasks, (e) => e._selected)
            parentContext.setNewTasks(filtered)
          },
        }}
      />

      <hr />
      <Footer />
    </React.Fragment>
  )
}
